/**
 * @generated SignedSource<<259c285b270a2f616dc009cedd43a87b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SportAndAgesText_game$data = {
  readonly endAge: number;
  readonly startAge: number;
  readonly title: string | null;
  readonly sport: {
    readonly name: string;
  };
  readonly " $fragmentType": "SportAndAgesText_game";
};
export type SportAndAgesText_game$key = {
  readonly " $data"?: SportAndAgesText_game$data;
  readonly " $fragmentSpreads": FragmentRefs<"SportAndAgesText_game">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SportAndAgesText_game",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sport",
      "kind": "LinkedField",
      "name": "sport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Game",
  "abstractKey": null
};

(node as any).hash = "09ff87084377af590aa012a3fa392875";

export default node;
